import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Ui } from "@silvertours/front-shared";
import { WaveContainer } from "./Container.styles";
export var WaveContentModuleContainer = function(param) {
    var children = param.children, rules = param.rules;
    var ref = rules || {}, _backgroundStyle = ref.backgroundStyle, backgroundStyle = _backgroundStyle === void 0 ? "default" : _backgroundStyle, _layoutFlow = ref.layoutFlow, layoutFlow = _layoutFlow === void 0 ? "right" : _layoutFlow, verticalSpacing = ref.verticalSpacing;
    var ref1 = verticalSpacing || {}, isLarge = ref1.isLarge, spacingDirection = ref1.spacingDirection;
    return /*#__PURE__*/ _jsx(Ui.Wave, {
        type: spacingDirection ? "scalable4" : "scalable1",
        fullWidth: true,
        backgroundStyle: backgroundStyle,
        children: /*#__PURE__*/ _jsx(WaveContainer, {
            isLarge: isLarge,
            layoutFlow: layoutFlow,
            backgroundStyle: backgroundStyle,
            spacingDirection: spacingDirection,
            children: children
        })
    });
};
